import React, { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import '../App.css'; // Ensure CSS is imported

const Navbar = () => {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    // 1. Clears token/user from LocalStorage via Context
    logout(); 
    // 2. Redirects to Login page
    navigate('/'); 
  };

  return (
    <nav className="navbar">
      <div className="nav-brand">
        <h3 style={{ margin: 0 }}>OnRoad Assist 🛠️</h3>
      </div>
      
      {user && (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          
          <button 
            className="btn-logout" 
            onClick={handleLogout}
            style={{
              background: 'transparent',
              border: '1px solid white',
              color: 'white',
              padding: '5px 12px',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Logout
          </button>
        </div>
      )}
    </nav>
  );
};

export default Navbar;